import React from "react";
import Canonical from "../components/Canonical";

const TermsOfUse = () => {
  const canonicalUrl = "https://homesdekho.com/terms-of-use";
  const hrfLangTag = "https://homesdekho.com/terms-of-use";
  const title = "Terms and Conditions | HomesDekho User Guidelines";
  const description =
    "Understand the terms and conditions for using HomesDekho's services. Know your rights, obligations, and usage rules before accessing our platform.";

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={title}
        hrfLang={hrfLangTag}
        description={description}
      />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="privacy-txt mt-3">Terms Of Use</h1>
          </div>
          <div className="col-md-12">
            <h2 className="privacy-sub-txt mt-3">Use of our services:</h2>
            <p className="privacy-para">User accounts:</p>
            <p className="privacy-para">
              To use our services, you must register with Homes Dekho and
              confirm that you are above 18 years of age. During the account
              registration process, you may be required to provide details such
              as your name, location, mobile number, email ID, etc. These
              details help us personalize your experience. Providing outdated or
              incorrect information may affect the proper functioning of our
              services for you. You agree to maintain the confidentiality of
              your account password at all times and acknowledge that you are
              solely responsible for safeguarding it.
            </p>
            <p className="privacy-para">Text messaging/Emails:</p>
            <p className="privacy-para">
              By registering with Homes Dekho, you authorize us to send text
              messages and/or emails as part of the services offered on our
              website. These communications may include notifications regarding
              your account, updates on the status of requests you may have made,
              or messages where we are unable to reach you directly.
            </p>
            <p className="privacy-para">Network access and devices:</p>
            <p className="privacy-para">
              While accessing our website or user applications, internet service
              provider or carrier charges may apply. You agree to ensure your
              device remains updated with the necessary security features for
              safe usage.
            </p>
            <h2 className="privacy-sub-txt mt-3">Re-use of the information:</h2>

            <p className="privacy-para">
              You agree not to reuse any information displayed on this website
              for commercial gains without authorization from Homes Dekho. Any
              unauthorized use of such information for commercial purposes will
              make you solely liable for any damages or consequences arising
              from such use. Homes Dekho disclaims all liability in this regard.
            </p>
            <h2 className="privacy-sub-txt mt-3">
              Reproduction of the information:
            </h2>
            <p className="privacy-para">
              You agree not to copy, duplicate, or reproduce any content
              displayed on this website in any form without prior written
              approval from Homes Dekho.
            </p>
            <p className="privacy-para">You agree that you:</p>
            <p className="privacy-para">
              a. Are solely responsible for the content you post;
            </p>
            <p className="privacy-para">
              b. May not post any link or post messages that are obscene,
              racist, sexual or offensive to any particular cultural group,
              community and/or race;
            </p>
            <p className="privacy-para">
              c. May not post content that infringes the copyright of any third
              party in any manner whatsoever;
            </p>
            <p className="privacy-para">
              d. Will not post advertisements or solicit customers for your
              business by sharing links that direct traffic to websites not
              owned by Homes Dekho.
            </p>
            <h2 className="privacy-sub-txt mt-3">Changes to these terms:</h2>
            <p className="privacy-para">
              Homes Dekho reserves the right to modify these Terms of Use at any
              time without prior notice to visitors, including those who may
              have previously accessed or used our website.
            </p>
            <h2 className="privacy-sub-txt mt-3">Notices:</h2>
            <p className="privacy-para">
              Any notice to Homes Dekho must be given in writing and sent to our
              official registered office address.
            </p>
            <h2 className="privacy-sub-txt mt-3">Termination:</h2>
            <p className="privacy-para">
              Homes Dekho reserves the right to terminate your access to any of
              its services, with or without prior notice. We hold the sole and
              exclusive authority to grant or restrict access to our services in
              any form, including usage and browsing of our website.
            </p>
            <h2 className="privacy-sub-txt mt-3">Jurisdiction:</h2>
            <p className="privacy-para">
              Any dispute arising out of the use of the Homes Dekho website
              shall be subject to the sole and exclusive jurisdiction of the
              courts where Homes Dekho is registered.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
